// extracted by mini-css-extract-plugin
export default {"container":"PriceBox_container__u00+S"};